import styled, {StyledComponentProps} from 'styled-components';
import React from 'react';
import {BREAKPOINTS, COLORS, focusStyles} from '../styles';
import {ComponentMStyling, ComponentTextStyle} from '../styles/typography';
import {Z_INDEXES} from '../styles/z-indexes';
import {useFocusVisibleRef} from '../common';

export type StyledComponentPropsWithAs<
  C extends string | React.ComponentType<any>,
  T extends object,
  O extends object,
  A extends keyof any,
  AsC extends string | React.ComponentType<any> = C,
  FAsC extends string | React.ComponentType<any> = C
> = StyledComponentProps<C, T, O, A, FAsC> & { as?: AsC | undefined; forwardedAs?: FAsC | undefined };


export const NavItemDiv = styled.div`
  ${ComponentMStyling(ComponentTextStyle.Regular, COLORS.neutral_600)}

  margin: 0;
  padding: 0 21px 0 21px;
  height: 64px;

  ${BREAKPOINTS.LARGE} {
    height: 80px;
  }

  display: flex;
  align-items: center;
  text-align: center;
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    background-color: transparent;
    height: 3px;
    border-radius: 3px;
    left: 2px;
    right: 2px;
    bottom: 2px;
  }

  &.active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    background-color: ${COLORS.neutral_20};
    color: ${COLORS.neutral_800};

    &:after {
      background-color: ${COLORS.primary_600};
    }
  }

  &.disabled {
    color: ${COLORS.neutral_300};
    background-color: ${COLORS.neutral_100};

    &:after {
      background-color: ${COLORS.neutral_100};
    }
  }

  &:hover:not(.disabled) {
    z-index: ${Z_INDEXES.hover};
    background-color: ${COLORS.primary_20};
    color: ${COLORS.primary_700};

    &:after {
      background-color: ${COLORS.primary_700};
    }
  }

  &:active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    background-color: ${COLORS.primary_100};
    color: ${COLORS.primary_800};

    &:after {
      background-color: ${COLORS.primary_800};
    }
  }


  &:focus:not(.disabled) {
    ${focusStyles}
    outline-offset: -4px;
  }
`;


const NavItem = (props: StyledComponentPropsWithAs<string | React.ComponentType<any>, any, {}, never, string | React.ComponentType<any>, "div">) => {
  return (
    <NavItemDiv {...props} />
  );
};

export default NavItem;
